import { render, staticRenderFns } from "./SupplierQuote.vue?vue&type=template&id=524162a7"
import script from "./SupplierQuote.vue?vue&type=script&lang=js"
export * from "./SupplierQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports